var React = require('react');

function LockLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.464 19.465A5 5 0 0111 18h26a5 5 0 015 5v20a5 5 0 01-5 5H11a5 5 0 01-5-5V23a5 5 0 011.464-3.535zM11 20a3 3 0 00-3 3v20a3 3 0 003 3h26a3 3 0 003-3V23a3 3 0 00-3-3H11z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 2a10 10 0 00-10 10v6h20v-6A10 10 0 0024 2zm-8.485 1.515A12 12 0 0136 12v7a1 1 0 01-1 1H13a1 1 0 01-1-1v-7a12 12 0 013.515-8.485zm6.01 27.01a3.5 3.5 0 114.95 4.95 3.5 3.5 0 01-4.95-4.95zM24 31.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z","key":1})]);
}

LockLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = LockLight;

LockLight.default = LockLight;
